module.exports = __webpack_public_path__ + "img/42.bee6bcce.png";